import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheckIcon, ZapIcon, DownloadIcon, CheckCircle2Icon, LockIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
const bundleItems = [{
  label: 'Guía Principal: Hogar de Revista — El Método Perfect-Hang',
  value: '$29.94',
  isMain: true
}, {
  label: 'BONUS 1: La Guía de Medidas de Oro',
  value: '$15.00',
  isMain: false
}, {
  label: 'BONUS 2: El Secreto de las Telas Inteligentes',
  value: '$12.00',
  isMain: false
}];
export function CtaSection() {
  return <section id="precio" className="bg-[#1C1C1C] text-white px-5 md:px-12 py-12 md:py-18" data-id="element-13">
      <div className="max-w-xl mx-auto" data-id="element-14">
        {/* Social Proof */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center gap-2 mb-8" data-id="element-15">
          <div className="flex gap-1" data-id="element-16">
            {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-5 h-5 text-[#C9A96E] fill-[#C9A96E]" data-id="element-17" />)}
          </div>
          <p className="text-sm text-white/50 tracking-wide" data-id="element-18">
            4.9/5 · Más de 200 clientas satisfechas
          </p>
        </motion.div>

        {/* Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-center mb-8" data-id="element-19">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-white leading-tight mb-4" data-id="element-20">
            Todo lo que necesitas para{' '}
            <span className="italic text-[#C9A96E]" data-id="element-21">transformar tu hogar</span>
          </h2>
          <p className="text-base text-white/60 font-light leading-relaxed max-w-md mx-auto" data-id="element-22">
            Descarga instantánea. PDF de por vida. Sin cuotas mensuales.
          </p>
        </motion.div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#242424] rounded-2xl border border-white/10 overflow-hidden" data-id="element-23">
          {/* Bundle Header */}
          <div className="bg-[#C9A96E]/15 border-b border-[#C9A96E]/20 px-8 py-4 text-center" data-id="element-24">
            <span className="text-[#C9A96E] uppercase tracking-[0.2em] text-xs font-bold" data-id="element-25">
              📦 Paquete Completo — Todo Incluido
            </span>
          </div>

          <div className="p-8 md:p-10" data-id="element-26">
            {/* Bundle Items */}
            <div className="space-y-3 mb-8" data-id="element-27">
              {bundleItems.map((item, i) => <div key={i} className={`flex items-start justify-between gap-4 pb-3 ${i < bundleItems.length - 1 ? 'border-b border-white/5' : ''}`} data-id="element-28">
                  <div className="flex items-start gap-3 flex-1" data-id="element-29">
                    <CheckCircle2Icon className={`w-4 h-4 flex-shrink-0 mt-0.5 ${item.isMain ? 'text-[#C9A96E]' : 'text-emerald-400'}`} data-id="element-30" />
                    <span className={`text-sm leading-snug ${item.isMain ? 'text-white font-semibold' : 'text-white/70'}`} data-id="element-31">
                      {item.label}
                    </span>
                  </div>
                  <span className="text-sm text-white/40 line-through whitespace-nowrap flex-shrink-0" data-id="element-32">
                    {item.value}
                  </span>
                </div>)}
            </div>

            {/* Total Value */}
            <div className="bg-white/5 rounded-xl px-6 py-4 mb-6 text-center" data-id="element-33">
              <p className="text-xs text-white/40 uppercase tracking-widest mb-1" data-id="element-34">
                Valor total del paquete
              </p>
              <p className="text-xl text-white/40 line-through font-medium" data-id="element-35">
                $66.94 USD
              </p>
            </div>

            {/* Price */}
            <div className="text-center mb-2" data-id="element-36">
              <p className="text-xs text-white/50 uppercase tracking-widest mb-1" data-id="element-37">
                Precio de lanzamiento — 50% OFF
              </p>
              <div className="flex items-baseline justify-center gap-2" data-id="element-38">
                <span className="text-6xl md:text-7xl font-bold text-[#C9A96E] leading-none" data-id="element-39">
                  $14.97
                </span>
                <span className="text-xl text-[#C9A96E]/70 font-light" data-id="element-40">
                  USD
                </span>
              </div>
            </div>

            {/* Savings callout */}
            <div className="text-center mb-8" data-id="element-41">
              <span className="inline-block px-4 py-1.5 bg-emerald-500/15 text-emerald-400 text-xs font-bold uppercase tracking-wider rounded-full border border-emerald-500/20" data-id="element-42">
                Ahorras $51.97 hoy
              </span>
            </div>

            {/* CTA Button — Emerald + Gold */}
            <a href="https://manosquegeneran.com/cart/48303873753315:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-base md:text-lg py-5 px-6 rounded-xl tracking-wide active:scale-[0.98] transition-all duration-200 uppercase text-center shadow-lg shadow-emerald-500/20 border border-[#C9A96E]/40" data-id="element-43">
              ⚡ Obtener Acceso Inmediato — $14.97
            </a>

            {/* Guarantee */}
            <div className="flex items-start gap-4 mt-6 bg-white/5 border border-white/10 rounded-xl p-5" data-id="element-44">
              <ShieldCheckIcon className="w-8 h-8 text-emerald-400 flex-shrink-0 mt-0.5" data-id="element-45" />
              <div data-id="element-46">
                <p className="text-white font-semibold text-sm mb-1" data-id="element-47">
                  Garantía de Devolución de 7 Días — 100% Sin Riesgo
                </p>
                <p className="text-white/50 text-xs leading-relaxed" data-id="element-48">
                  Si en 7 días no estás completamente satisfecha con los
                  resultados, te devolvemos cada centavo. Sin preguntas.
                </p>
              </div>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3 mt-6" data-id="element-49">
              <div className="flex items-center gap-2 text-white/40 text-xs" data-id="element-50">
                <LockIcon className="w-3.5 h-3.5 text-[#C9A96E]/60" data-id="element-51" />
                <span data-id="element-52">Pago Seguro SSL</span>
              </div>
              <div className="flex items-center gap-2 text-white/40 text-xs" data-id="element-53">
                <ZapIcon className="w-3.5 h-3.5 text-[#C9A96E]/60" data-id="element-54" />
                <span data-id="element-55">Acceso Instantáneo</span>
              </div>
              <div className="flex items-center gap-2 text-white/40 text-xs" data-id="element-56">
                <DownloadIcon className="w-3.5 h-3.5 text-[#C9A96E]/60" data-id="element-57" />
                <span data-id="element-58">PDF Digital — Acceso de Por Vida</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Micro-copy */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-xs text-white/25 leading-relaxed text-center mt-6 max-w-sm mx-auto" data-id="element-59">
          Compra única. Descarga inmediata del PDF tras el pago. Acceso de por
          vida garantizado. Sin suscripciones ni cuotas mensuales.
        </motion.p>
      </div>
    </section>;
}